var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFootSportsAc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.333,
    height: 24.333,
    viewBox: "0 0 24.333 24.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "football",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    d: "M14.167,2A12.167,12.167,0,1,0,26.333,14.167,12.181,12.181,0,0,0,14.167,2Zm8.982,17.44a.863.863,0,0,0-.291-.059h-3.88L17.75,17.542l1.468-3.671,2.114-1.41,3.226,2.419A10.343,10.343,0,0,1,23.148,19.44ZM5.476,19.381a.863.863,0,0,0-.291.059A10.348,10.348,0,0,1,3.878,15.79l3.24-2.477,2.046.682,1.419,3.547L9.357,19.381ZM5.035,9.14l1.084,2.749-2.356,1.8A10.359,10.359,0,0,1,5.035,9.14Zm7.113,7.634-1.307-3.267,3.326-3.326,3.326,3.326-1.307,3.267ZM22.278,11l.841-2.151a10.355,10.355,0,0,1,1.351,3.8Zm-.379-3.8-1.481,3.785v0l-1.8,1.2L15.036,8.593V6.641l3.121-2.107A10.469,10.469,0,0,1,21.9,7.194ZM15.98,3.906,14.134,5.153,12.464,3.89a9.732,9.732,0,0,1,3.515.017Zm-5.628.564L13.3,6.7V8.593L9.587,12.3l-1.654-.551L6.226,7.423A10.463,10.463,0,0,1,10.352,4.471ZM6.416,21.119H9.161l.7,2.536A10.467,10.467,0,0,1,6.416,21.119Zm5.44,3.209L10.765,20.4l1.26-1.889h4.284L17.567,20.4l-1.1,3.932a10.139,10.139,0,0,1-4.609,0Zm6.6-.668.712-2.541h2.747A10.476,10.476,0,0,1,18.458,23.661Z",
    fill: "#c9a145"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootSportsAc);
export default __webpack_public_path__ + "static/media/foot-sports-ac.c30ef590533c5cbf3f1f793adc177ae1.svg";
export { ForwardRef as ReactComponent };